import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "../table.module.scss";

interface PaymentRecordsTableSkeletonProps {
  count?: number;
  className?: string;
}

const COLUMNS = [
  "Transaction ID",
  "Amount",
  "Method",
  "Instalment",
  "Status",
  "Due date",
  "Purchased date",
  "Receipt",
];

/** Same eight columns and row height as the loaded payments table. */
function PaymentRecordsTableSkeleton({
  count = 3,
  className,
}: PaymentRecordsTableSkeletonProps) {
  return (
    <div className={classNames(styles.card, className)}>
      <div className={styles.heading}>
        <Skeleton variant="text" width={160} height={28} />
      </div>
      <div className={styles.scroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              {COLUMNS.map((column) => (
                <th key={column} className={styles.th}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: count }).map((_, index) => (
              <tr key={index}>
                <td className={styles.td}>
                  <Skeleton variant="text" width={92} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={82} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={94} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={52} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton
                    variant="rounded"
                    width={78}
                    height={22}
                    sx={{ borderRadius: "16px" }}
                  />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={88} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={88} height={20} />
                </td>
                <td className={styles.td}>
                  <div className={styles.actions}>
                    <Skeleton variant="circular" width={32} height={32} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PaymentRecordsTableSkeleton;
